import { AxiosRequestConfig } from 'axios'

import { axiosInstance, paymentAxiosInstance, FIREBASE_URL } from './axios'
interface CustomConfig extends AxiosRequestConfig {
  requireAuth?: boolean
}

// Helper to configure request
const configureRequest = (requireAuth: boolean, config: CustomConfig = {}) => {
  return {
    ...config,
    requireAuth: requireAuth || config?.requireAuth || false, // Use a property instead of a header
  }
}

export const get = async (
  url: string,
  params = {},
  config: CustomConfig = {},
  requireAuth = true,
) => {
  try {
    const response = await axiosInstance.get(url, {
      ...configureRequest(requireAuth, config),
      params,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const post = async (
  url: string,
  data = {},
  config: CustomConfig = {},
  requireAuth = true,
) => {
  try {
    const response = await axiosInstance.post(url, data, configureRequest(requireAuth, config))
    if (response.status === 200) {
      return response.data
    }
    throw new Error(response.statusText)
  } catch (error) {
    throw error
  }
}

export const put = async (
  url: string,
  data = {},
  config: CustomConfig = {},
  requireAuth = true,
) => {
  try {
    const response = await axiosInstance.put(url, data, configureRequest(requireAuth, config))
    return response.data
  } catch (error) {
    throw error
  }
}

export const del = async (url: string, config: CustomConfig = {}, requireAuth = true) => {
  try {
    const response = await axiosInstance.delete(url, configureRequest(requireAuth, config))
    return response.data
  } catch (error) {
    throw error
  }
}

export const getPayment = async (
  url: string,
  params = {},
  config: CustomConfig = {},
  requireAuth = true,
) => {
  try {
    const response = await paymentAxiosInstance.get(url, {
      ...configureRequest(requireAuth, config),
      params,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const postPayment = async (
  url: string,
  data = {},
  config: CustomConfig = {},
  requireAuth = true,
) => {
  try {
    const response = await paymentAxiosInstance.post(
      url,
      data,
      configureRequest(requireAuth, config),
    )
    if (response.status === 200) {
      return response.data
    }
    throw new Error(response.statusText)
  } catch (error) {
    throw error
  }
}

export const postFirebase = async (url: string, data = {}) => {
  try {
    const response = await axiosInstance.post(url, data, {
      baseURL: FIREBASE_URL,
      // @ts-expect-error assignable
      requireAuth: false,
    })

    if (response.status !== 200) {
      throw new Error('Failed to track refcode')
    }
  } catch (error) {
    throw error
  }
}
